import { BaseModel, Guid, RecursivePartial } from '@models/base';
import { WorkflowTarget } from './workflow-target';

export class WorkflowState extends BaseModel {
    id?: Guid;
    title?: string;
    description?: string;
    icon?: string;
    color?: string;
    targets: WorkflowTarget[] = [];          // must have at least one target
    recordTime?: boolean;

    constructor(json?: RecursivePartial<WorkflowState>) {
        super(json);
        this.parseWorkflowState(json || {});
    }

    parse(json: RecursivePartial<WorkflowState>): WorkflowState {
        super.parse(json);
        this.parseWorkflowState(json);
        return this;
    }

    private parseWorkflowState(json: RecursivePartial<WorkflowState>): void {
        WorkflowState.assignFields(this, json, ['id', 'title', 'description', 'icon', 'color', 'recordTime']);
        WorkflowState.assignClassArrays(this, json, { targets: WorkflowTarget });
        if (this.title == null) {
            this.title = 'Статус-' + this.id;
        }
    }

}
